import React, { createContext, useContext, useState } from "react";

const AdminRolesListContext = createContext();

export const AdminRolesListProvider = ({ children }) => {
  const [message, setMessage] = useState("Esto un mensaje de prueba");
  const [alertType, setAlertType] = useState("success");

  // Alert header
  const [showAlertHeader, setShowAlertHeader] = useState(false);
  const openAlertHeader = () => setShowAlertHeader(true);
  const closeAlertHeader = () => setShowAlertHeader(false);

  // Selección de rol + modal ver permisos (solo lectura)
  const [selectedRole, setSelectedRole] = useState(null);
  const [showRolePermissionsModal, setShowRolePermissionsModal] =
    useState(false);
  const openRolePermissionsModal = (role) => {
    setSelectedRole(role);
    setShowRolePermissionsModal(true);
  };
  const closeRolePermissionsModal = () => setShowRolePermissionsModal(false);

  return (
    <AdminRolesListContext.Provider
      value={{
        // alerts
        message,
        setMessage,
        alertType,
        setAlertType,
        showAlertHeader,
        openAlertHeader,
        closeAlertHeader,
        // roles
        selectedRole,
        showRolePermissionsModal,
        openRolePermissionsModal,
        closeRolePermissionsModal,
      }}
    >
      {children}
    </AdminRolesListContext.Provider>
  );
};

export const useAdminRolesListContext = () => useContext(AdminRolesListContext);
